/**
 * 将 /uploads/... 转为可访问的完整地址（线上不能用 localhost）
 */
export function resolveMediaUrl(path) {
  if (path == null || path === '') {
    return ''
  }
  let url = String(path).trim()
  if (!url) {
    return ''
  }
  if (/^https?:\/\//i.test(url)) {
    return url
  }
  if (url.startsWith('//')) {
    return window.location.protocol + url
  }
  const envBase = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '')
  const base = envBase || window.location.origin.replace(/\/$/, '')
  if (!url.startsWith('/')) {
    url = '/' + url
  }
  return base + url
}

export function recordingAudioSrc(detail) {
  if (!detail || Number(detail.question_type) !== 3) {
    return ''
  }
  const raw = detail.user_answer_audio_url || detail.user_answer
  return resolveMediaUrl(raw)
}
